<template>
  <div>
    <template v-if="isLaunchpack">
      <superadmin-dashboard v-if="isAdmin"></superadmin-dashboard>
      <superadmin-partner-dashboard v-else></superadmin-partner-dashboard>
    </template>
    <dashboard v-else></dashboard>
  </div>
</template>

<script>
  import SuperadminDashboard from "./SuperadminDashboard";
  import SuperadminPartnerDashboard from "./SuperadminPartnerDashboard";
  import Dashboard from "./Dashboard";
  export default {
    name: "Dashboards",
    components: {
      Dashboard,
      SuperadminDashboard,
      SuperadminPartnerDashboard,
    },
    created() {

    },
    data() {
      return {}
    },
    methods: {}
  }
</script>

<style lang="stylus" scoped>

</style>
